{
  "projects": [
    {
      "title": "Sii TestingLab Jury",
      "desc": "A recurring Sii research programme evaluating software testing tools against real scenarios. On the jury I help define the study scope, design the testing scenarios and the evaluation criteria, perform the code reviews behind the technical assessment, and co-author the final report.",
      "tags": [
        "Code Review",
        "AI-driven testing",
        "Quality Engineering"
      ],
      "icon": "CodeXml",
      "featured": true,
      "links": [
        {
          "label": "Report: Testing Lab - AI Edition",
          "group": "AI Testing Lab Study, part one · 04.2026",
          "url": "https://sii.pl/en/news-feed/ai-in-software-testing-sii-poland-publishes-a-breakthrough-testing-lab-ai-edition-report/",
          "icon": "Lightbulb"
        },
        {
          "label": "Study: exploring the AI boom in test automation",
          "group": "AI Testing Lab Study, part one · 04.2026",
          "url": "https://sii.pl/blog/en/sii-testing-lab-study-exploring-the-ai-boom-in-test-automation/",
          "icon": "BookOpen"
        },
        {
          "label": "Report: Testing Lab - AI is not enough",
          "group": "AI Testing Lab Study, part two · 08.2026",
          "url": "https://sii.pl/en/news-feed/ai-speeds-up-software-testing-but-does-it-help-find-the-right-bugs-sii-poland-publishes-the-second-testing-lab-report/",
          "icon": "Lightbulb"
        }
      ]
    },
    {
      "title": "Polish Testing Board (SJSI) Vice-President",
      "desc": "As Vice President of the Polish Testing Board, I contribute to the development and promotion of professional standards in software testing and quality assurance. I regularly host major industry conferences such as TestWarez and Na Podbój IT, helping facilitate discussions within the testing community.",
      "tags": [
        "Leadership",
        "ISTQB",
        "Speaker",
        "TestWarez",
        "Na Podbój IT!"
      ],
      "icon": "Users",
      "links": [
        {
          "label": "SJSI board",
          "url": "https://sjsi.org/o-nas/zarzad/#:~:text=REMIGIUSZ%20BEDNARCZYK",
          "icon": "Globe"
        }
      ]
    },
    {
      "title": "Lead Technical Assessor",
      "desc": "I lead an internal technical assessment program focused on evaluating the skills and seniority of software testing professionals. My role includes conducting technical interviews (from Junior Testers to Test Managers), managing a team of Technical Assessors, and continuously improving the assessment framework and knowledge base.",
      "tags": [
        "Technical Assesment",
        "Quality Assurance",
        "ISTQB",
        "Leadership",
        "Mentoring"
      ],
      "icon": "Award"
    },
    {
      "title": "ISTQB Training & Mentoring",
      "desc": "Conducting trainings and workshops for various clients such as Sii Poland and Testerzy.pl, while mentoring engineers in leadership, test management, and technical skills to raise their overall technical proficiency.",
      "tags": [
        "Training",
        "Mentoring",
        "ISTQB",
        "Workshops"
      ],
      "icon": "BookOpen",
      "links": [
        {
          "label": "Become a tester — the course that can turn a career around (Sii)",
          "url": "https://sii.pl/aktualnosci/zostan-testerem-szkolenie-ktore-moze-zmienic-sciezke-kariery-o-180-stopni/",
          "icon": "Globe"
        },
        {
          "label": "Trainer profile at Testerzy.pl",
          "url": "https://testerzy.pl/trenerzy/remigiusz-bednarczyk",
          "icon": "Globe"
        }
      ]
    },
    {
      "title": "Technical Writer (QA & Engineering)",
      "desc": "Author and co-author of technical articles on software testing, data systems and QA practices, contributing to knowledge sharing across engineering teams.",
      "tags": [
        "Technical Writing",
        "Knowledge Sharing",
        "QA Practices"
      ],
      "icon": "Rss",
      "links": [
        {
          "label": "The story of the Sii blog: passion and knowledge to millions of views",
          "url": "https://sii.pl/aktualnosci/od-pasji-i-wiedzy-do-milionow-odslon-czyli-historia-bloga-sii/",
          "icon": "Globe"
        },
        {
          "label": "All my articles on the Sii blog",
          "url": "https://sii.pl/blog/author/remigiusz-bednarczyk/",
          "icon": "Lightbulb"
        }
      ]
    },
    {
      "title": "Brand Ambassador",
      "desc": "Featured as a Brand Ambassador in nationwide campaigns, including the #UnstoppableSii eco-murals project across major Polish cities. Selected as a company representative for the Great Place to Work campaign and official Sii Calendars, actively contributing to employer branding and organizational culture.",
      "tags": [
        "Employer Branding",
        "Brand Ambassador",
        "#UnstoppableSii",
        "Community"
      ],
      "icon": "Image",
      "links": [
        {
          "label": "Sii turns 15: eco-murals in five cities",
          "url": "https://sii.pl/en/news-feed/sii-poland-celebrates-its-15th-birthday-with-eco-murals-5-walls-absorb-as-much-smog-as-over-1-000-trees/",
          "icon": "Globe"
        }
      ]
    }
  ]
}
